import React, { Fragment, useState, useContext, useEffect } from 'react';
import { MapContext } from '_context/MapContext';
import { LayoutContext } from '_context/LayoutContext';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';

let now = new Date().getTime();

const poiSeqLabel = (idx, numberType=false) => {
    if(numberType){
        return (idx+1)+''
    }else{
        return String.fromCharCode(65+idx)
    }
}

const chkHttp=(link)=>{
    if (link.search(/^http[s]?\:\/\//) === -1) {
        link = 'http://' + link;
    }
    return link;
}

const PlaceBody = ({ alphaNum, idx, obj, mode,target,setRoutePoi, poiSeqLabelType}) => {

    const { chgStatus } = useContext(LayoutContext);
    const { setRP } = useContext(MapContext);

    
    const setRPPath = (event, key, keyword, point) =>{ 
        event.stopPropagation()
        let rp = {
            keyword : keyword,
            point
        }
        setRP(key,rp,key==='wayPoints'?'add':null);
        chgStatus("rp");
    }


    return (
        <Fragment>
        <div className="name"><span className="num">{alphaNum?alphaNum+(idx+1):poiSeqLabel(idx, poiSeqLabelType)}</span> {obj.name} {obj.branch} {obj.subName?obj.subName:''}</div>
        <div className="info">
        <span className="kind">{obj.category.masterName}</span>
        {obj.phones && <span className="tel">{obj.phones.representation[0]}</span>}
        {obj.extension && obj.extension.homepageURL && <a href={chkHttp(obj.extension.homepageURL)} target="_blank" className="web">홈페이지</a>}
        </div>
        <div className="address">{obj.address.siDo}{' '}{obj.address.siGunGu}{' '}{obj.address.street}{' '}{obj.address.streetNumber}</div>
        <div className="address"><span className="jibun">지번</span>{' '}{obj.address.eupMyeonDong}{' '}{obj.address.houseNumber}</div>
        {
            (mode === "rp" && !poiSeqLabelType) && 
            <div  className={target==="start"?"iconsNavi icStart":target==="end"?"iconsNavi icDest":"iconsNavi icWaypoint"} onClick={()=>setRoutePoi(target,obj.name+(obj.branch?' '+obj.branch:'')+(obj.subName?' '+obj.subName:''),obj.point)}>
                <span>{target==="start"?"출발":target==="end"?"도착":"경유"}</span>
            </div>
        }
      {
          mode!=="rp" &&
          <Fragment>
          <div className="departureArrival">
                <button className="ic_start" onClick={(e)=>setRPPath(e, "start",obj.name+(obj.branch?' '+obj.branch:'')+(obj.subName?' '+obj.subName:''),obj.point)}><span className="btnsSch"></span>출발</button>
                <button className="ic_waypoint" onClick={(e)=>setRPPath(e, "wayPoints",obj.name+(obj.branch?' '+obj.branch:'')+(obj.subName?' '+obj.subName:''),obj.point)}><span className="btnsSch"></span>경유지</button>
                <button className="ic_arrival" onClick={(e)=>setRPPath(e, "end",obj.name+(obj.branch?' '+obj.branch:'')+(obj.subName?' '+obj.subName:''),obj.point)}><span className="btnsSch"></span>도착</button>
            </div>
          <div className="icons">
          {/* <button className="btnsSch ic_share" title="공유하기">공유하기</button>
          <button className="btnsSch ic_theme" title="주변테마">주변테마</button>
          <button className="btnsSch ic_infomod" title="장소정보 수정">장소정보 수정</button>
          <button className="btnsSch ic_bookmark" title="즐겨찾기">즐겨찾기</button> */}
            </div>
            {obj.extension && obj.extension.photoURL && <img src={obj.extension.photoURL} alt="" className="photo" />}
            </Fragment>
      }
        </Fragment>
    )
}


export const PlaceList = ({idx, obj, isActive,setHistory, mode, target, setRoutePoi, poiSeqLabelType}) => {
    const { status } = useContext(LayoutContext);

    const [isChildren, setIsChildren] = useState(false);
   
    const { selectedPoi, selectedId,selExpand } = useContext(MapContext);

    const selList = (obj) =>{ 
        selectedPoi(obj.id);

        if(mode!=="rp"){
            //setHistory({"name":obj.name+(obj.branch?' '+obj.branch:'')+(obj.subName?' '+obj.subName:''), "point":obj.point, "timestamp":now})
            setHistory({"name":obj.name+(obj.branch?' '+obj.branch:'')+(obj.subName?' '+obj.subName:''), "point":obj.point})
        } 
    }

    useEffect(() => {
        if(selectedId!==obj.id && obj.children && obj.children.filter((child)=>{if(child.id===selectedId) return child;}).length===0){
            setIsChildren(false)
        }
    }, [selectedId]);

    useEffect(() => {
        setIsChildren(false)
    }, [status]);

    return (
        <React.Fragment>
        <li id={"list-"+obj.id} onClick={(e)=>selList(obj)} className={isActive ? "current":""} >
        <PlaceBody type="p" idx={idx} obj={obj} mode={mode} target={target} setRoutePoi={setRoutePoi} poiSeqLabelType={poiSeqLabelType}/>
        {status==='search' && obj.children && obj.children.length>0 &&
        <span className="associationAreas">
            <button onClick={(e) => {e.stopPropagation(); setIsChildren(!isChildren); selList(obj); selExpand(obj.id,isChildren)}} className={isChildren?"open":""}><span className="txt">연관장소보기({obj.children.length})</span> <span className="iconsArrow"></span></button>
        </span>
        }
        </li>
        {isChildren && obj.children && obj.children.map((row,i)=>
            <li style={{padding:'16px 26px'}} id={"list-"+row.id} className={selectedId===row.id ? "relevantPlace current":"relevantPlace"} key={i} onClick={(e)=>{e.stopPropagation(); selList(row)}}>
            <PlaceBody type="c" poiSeqLabelType={poiSeqLabelType} alphaNum={poiSeqLabel(idx, poiSeqLabelType)} idx={i} obj={row}  mode={mode} target={target}  setRoutePoi={setRoutePoi}/>
            </li>
        )}
        </React.Fragment>
    );
  };



 export const AddrList = ({idx, obj, isActive,setHistory,mode, target, setRoutePoi}) => {
    const { selectedPoi,setRP } = useContext(MapContext);
    const { chgStatus } = useContext(LayoutContext);

    const onUpdate = (obj) =>{ 
        //let selObj = obj.parcelAddress.length>0?obj.parcelAddress[0]:obj.roadAddress[0];
        //let flag =  obj.parcelAddress.length>0?selObj.pnucode:selObj.rbucode;
        let selObj = obj.roadAddress.length>0?obj.roadAddress[0]:obj.parcelAddress[0];
        let flag =  obj.roadAddress.length>0?selObj.rbucode:selObj.pnucode;
        selectedPoi(flag);
        if(mode!=="rp"){
            setHistory({"name":selObj.fullAddress, "point":selObj.geographicInformation.point, "timestamp":now})
        }
    }

    const setRPPath2 = (event, key) =>{ 
        event.stopPropagation()
        let flag = obj.parcelAddress.length>0?"parcelAddress":"fullAddress";
        let keyword = obj[flag][0].fullAddress;
        let point = obj[flag][0].geographicInformation.point;

        let rp = {
            keyword : keyword,
            point
        }
        setRP(key,rp,key==='wayPoints'?'add':null);
        if(mode!=="rp"){
            chgStatus("rp");
        }
    }

    return (
        <li onClick={()=>onUpdate(obj)} className={isActive ? "current":""}>
        <div className="name">{obj.roadAddress.length>0?obj.roadAddress[0].fullAddress:obj.parcelAddress[0].fullAddress}</div>
        {  obj.roadAddress.length>0 && obj.parcelAddress.length>0 &&
            <div className="address"><span className="jibun">지번</span>{' '}{obj.parcelAddress[0].fullAddress}</div>
        }
        {
            mode === "rp" && 
            <div  className={target==="start"?"iconsNavi icStart":target==="end"?"iconsNavi icDest":"iconsNavi icWaypoint"}  onClick={(e)=>setRPPath2(e,target)} >
                <span>{target==="start"?"출발":target==="end"?"도착":"경유"}</span>
            </div>
        }
        {
            mode!=="rp" &&
            <Fragment>    
        <div className="departureArrival">
        <button className="ic_start" onClick={(e)=>setRPPath2(e,"start")}><span className="btnsSch"></span>출발</button>
        <button className="ic_waypoint" onClick={(e)=>setRPPath2(e,"wayPoints")}><span className="btnsSch"></span>경유지</button>
        <button className="ic_arrival" onClick={(e)=>setRPPath2(e,"end")}><span className="btnsSch"></span>도착</button>
         </div>
        {/* <div className="icons">
            <button className="btnsSch ic_bookmark" title="즐겨찾기">즐겨찾기</button>
        </div> */}
        </Fragment>
        }
    </li>
    );
  };


  
export const AddrResult = ({addrTotal, addrData, addrBlock, setAddrBlock, setHistory, mode, target, setRoutePoi}) => {
    const [state, setState] = useState(false);
    const { selectedId,setMapOpts,opts } = useContext(MapContext);
  
    const onClick = () =>{
      setState(true)
    }

  
    return (
      <React.Fragment>
              <div className="wrapTop">
                  <div className="resultNum">주소 <span className="num">{addrTotal}</span>건 </div>
                  <div className="btnWrap">
                      <button className="btnToggle" onClick={() => setMapOpts("isAddr",!opts.isAddr)} style={{paddingRight:'0px'}}>{opts.isAddr?'지도에서 감추기':'지도에서 보이기'} </button>
                      <button className="btnToggle" onClick={() => setAddrBlock(!addrBlock)} >  <span className="btnsSch" ></span></button>

                  </div>
              </div>
            {
                addrBlock &&
              <OverlayScrollbarsComponent
              style={{maxHeight:'275px'}} 
              >
              <div className="list address">
                  <ul>
                  {addrData.map((row,i)=>
                     <AddrList key={i} idx={i} obj={row} isActive={row.parcelAddress.length>0&&selectedId===row.parcelAddress[0].pnucode?true:false} 
                     setHistory={setHistory}   mode={mode} target={target}  setRoutePoi={setRoutePoi}/>
                   )}                      
                  </ul>
                  </div>
                  </OverlayScrollbarsComponent>
            }
              </React.Fragment>
    )
  }
  
  